import deadHorseImage from "../../../static/images/protone_pedals_bundle/dead-horse.webp";
import midBoostImage from "../../../static/images/protone_pedals_bundle/cor-mid-boost.webp";
import monsterFuzzImage from "../../../static/images/protone_pedals_bundle/monster-fuzz.webp";

export const INCLUDED_PRODUCTS = [
  {
    id: "protone-deadhorse",
    name: "Dead Horse Overdrive",
    category: "Overdrive",
    image: deadHorseImage,
    width: 1340,
    height: 1306,
    description: "The digital edition of ProTone's flagship overdrive. Tighten your rhythm tone, add bite to an amp or push a lead forward with the character of the original Dead Horse.",
    features: [
      "Classic Dead Horse and Tube Screamer-style response",
      "Bass Frequency Selector for shaping the low end",
      "Drive, tone and attack controls",
    ],
  },
  {
    id: "protone-midboost",
    name: "Cor Mid Boost",
    category: "Midrange boost",
    image: midBoostImage,
    width: 1340,
    height: 1306,
    description: "Bring your guitar forward with focused midrange shaping. Add definition to a scooped sound, give a lead more presence or find the right balance in a dense mix.",
    features: [
      "Adjustable midrange level and frequency",
      "Voice control for subtle or aggressive shaping",
      "Works with clean, overdriven and distorted tones",
    ],
  },
  {
    id: "protone-monsterfuzz",
    name: "Monster Fuzz",
    category: "Fuzz",
    image: monsterFuzzImage,
    width: 1700,
    height: 1306,
    description: "A characterful fuzz with plenty of room to experiment. Shape the low-end growl, filtered bite and sustained saturation with controls that go beyond a conventional fuzz pedal.",
    features: [
      "Fuzz, filter and volume controls",
      "Scoop and Voice controls for midrange character",
      "Crunch and Clip controls for compression and sustain",
    ],
  },
];

export interface StoreProduct {
  id: string;
  name: string;
  metadata?: Record<string, string>;
  owned?: boolean;
  default_price?: {
    id: string;
    currency: string;
    unit_amount: number;
  } | null;
}

export function getProductPrice(product?: StoreProduct) {
  const price = product?.default_price;
  if (!price?.id || !/^[a-z]{3}$/i.test(price.currency) ||
    !Number.isSafeInteger(price.unit_amount) || price.unit_amount < 0) {
    return undefined;
  }
  return price;
}

export function formatPrice(amount: number, currency: string) {
  const formatter = new Intl.NumberFormat("en-IE", { style: "currency", currency });
  const decimals = formatter.resolvedOptions().maximumFractionDigits;
  return formatter.format(amount / Math.pow(10, decimals));
}
